import React, {Component} from 'react';
import notifier from './../lib/notifier';
import {Button, Col, Container, FormGroup, Label} from "reactstrap";
import {post} from './../lib/http';
import BoundTextInput from "./forms/BoundTextInput";
import fetchLookups from "../lib/fetchLookups";
import _ from 'lodash';
import BoundSelect from "./forms/BoundSelect";
import isNullOrWhitespace from "../lib/isNullOrWhitespace";
import AppActions from "../actions/AppActions";

export class HealthAndSafetySync extends Component {
    componentWillMount() {
        this.update();
    }

    render() {
        const {sync} = this.props;

        return (
            <Container fluid>
                <h1>Health and safety sync</h1>
                <h3>Sync data with digital twin</h3>

                {sync && <div>
                    <FormGroup row>
                        <Label for="MixId" sm={2}>Mix id</Label>
                        <Col sm={4}>
                            <BoundTextInput value={sync.mixId} path="sync.mixId" id="MixId"
                                            className="form-control input-md"/>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label for="SiteName" sm={2}>Site name</Label>
                        <Col sm={4}>
                            {this.renderSiteName()}
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={6}>
                            <Button color="primary" className="float-right" onClick={() => this.sync()}>Sync</Button>
                        </Col>
                    </FormGroup>
                </div>}
            </Container>
        );
    }

    renderSiteName() {
        const {lookups, sync} = this.props;

        const lookupOptions = _.map(lookups && lookups.siteName, lookup => ({
            value: lookup,
            text: lookup
        }));

        const options = [{value: '', text: '<SELECT>'}, ...lookupOptions];

        return <BoundSelect
            path="sync.siteName"
            value={sync.siteName || ''}
            options={options}/>;
    }

    sync() {
        const {sync} = this.props;

        const isValidMixId =
            (/^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i)
                .exec(sync.mixId);

        if (!isValidMixId) {
            notifier.notify({
                level: notifier.Level.Error,
                title: 'Error',
                message: 'Invalid mix id'
            });

            return;
        }

        if (isNullOrWhitespace(sync.siteName)) {
            notifier.notify({
                level: notifier.Level.Error,
                title: 'Error',
                message: 'Site name not set'
            });

            return;
        }

        const onSyncComplete = (content) => {
            notifier.notify({
                level: notifier.Level.Success,
                title: 'Success',
                message: 'Sync complete'
            });
        };

        post('api/incidents/sync', sync, onSyncComplete);
    }

    update() {
        const {lookups} = this.props;

        AppActions.updateState('sync', {
            siteName: '',
            mixId: window.localStorage.getItem('mixId') || ''
        });

        if (!lookups) {
            fetchLookups();
        }
    }
}